var map = {
	"./adult/nn/5 1 Leseforstaelse Intro.mp3": 802,
	"./adult/no/5 1 Leseforstaelse Intro.mp3": 803,
	"./adult/se/5 1 Leseforstaelse Intro.mp3": 804,
	"./youth/de/5 1 Leseforstaelse Intro.mp3": 805,
	"./youth/nn/5 1 Leseforstaelse Intro.mp3": 806,
	"./youth/no/5 1 Leseforstaelse Intro.mp3": 807,
	"./youth/se/5 1 Leseforstaelse Intro.mp3": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;